import * as React from "react";
/**
 * The icon representing a PowerPoint file
 */ export const PowerPointFile = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.5 22H21.5C21.775 22 22 21.775 22 21.5V7H18.5C17.673 7 17 6.327 17 5.5V2H7.5C7.225 2 7 2.225 7 2.5V21.5C7 21.775 7.225 22 7.5 22Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M21.293 6.00003L18 2.70703V5.50003C18 5.77503 18.225 6.00003 18.5 6.00003H21.293Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.67",
        d: "M17.0859 1C17.4833 1.00117 17.8647 1.15936 18.1465 1.43945L22.5596 5.85352C22.8436 6.13652 23 6.51406 23 6.91406V21.5C23 22.327 22.327 23 21.5 23H7.5C6.673 23 6 22.327 6 21.5V2.5C6 1.673 6.673 1 7.5 1H17.0859ZM7.5 2C7.225 2 7 2.225 7 2.5V21.5C7.00055 21.7759 7.22409 21.9995 7.5 22H21.5C21.775 22 22 21.775 22 21.5V7H18.5C17.673 7 17 6.327 17 5.5V2H7.5ZM18 5.5C18.0006 5.77591 18.2241 5.99945 18.5 6H21.293L18 2.70703V5.5Z",
        fill: "#605E5C"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.95 12H17L16 11H15L14 12V14.945C14.6566 15.6199 15.5584 16.0004 16.5 16C18.433 16 20 14.433 20 12.5C20 12.329 19.973 12.165 19.95 12Z",
        fill: "#ED6C47"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16.5 9C15.511 9 14.633 9.42 14 10.08V12H17V9.05C16.835 9.027 16.671 9 16.5 9Z",
        fill: "#FF8F6B"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M18.0498 10.95H20.9998C20.7799 9.42106 19.5787 8.2199 18.0498 8V10.95Z",
        fill: "#FFC7B5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2 19H12C12.5523 19 13 18.5523 13 18V8C13 7.44772 12.5523 7 12 7H2C1.44772 7 1 7.44772 1 8V18C1 18.5523 1.44772 19 2 19Z",
        fill: "#C43E1C"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.3623 10C8.07209 10 8.37212 10.1605 8.74707 10.4805C9.12489 10.8025 9.31348 11.2661 9.31348 11.875C9.31348 12.2649 9.30823 12.78 8.89844 13.2949C8.57045 13.7069 8.14403 14.005 7.28809 14H6V16H5V10H7.3623ZM6 13H7.15527C7.54509 13 7.83816 12.9132 8.03711 12.7383C8.23511 12.5653 8.33496 12.3106 8.33496 11.9746C8.33481 11.325 7.95397 11.0001 7.19336 11H6V13Z",
        fill: "#F9F7F7"
    }));
